module.exports = __webpack_public_path__ + "static/img/Leadership.dfb2f12.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact/Leadership.png
// module id = SyId
// module chunks = 1